var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.options,"label":_vm.label,"outlined":"","dense":"","hide-details":""},on:{"change":_vm.onChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=_vm._n($$v)},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }